import { useMemo } from "react";
import { useSelector } from "react-redux";
import { get } from "lodash";

/**
 * key is a string "path" to the desired dictionary. Separate "levels" with a period.
 * Example: "common.assignSelected"
 */
export const useDictionary = (key = '', overrides = {}) => {
	const dictionaryStore = useSelector(state => state.dictionary);

	return useMemo(() => {
		return { ...get(dictionaryStore, key, {}), ...overrides };
	}, [ dictionaryStore, key, overrides ]);
};

export default useDictionary;
